// Initial state
const initialState = {
  isLoggedIn: false,
  isAdmin: false,
  userDetails: {
    client_account_no: "",
    clientName: "",
    clientPersonName: "",
    clientCompanyName: "",
    icon_path: "",
  },
};

// Login data mutations
const mutations = {
  IS_LOGGED_IN_UPDATE(state, payload) {
    state.isLoggedIn = payload;
  },
  IS_ADMIN_UPDATE(state, payload) {
    state.isAdmin = payload;
  },
  setUserDetails(state, payload) {
    state.userDetails = payload;
  },
};

// Login data actions
const actions = {
  //login info
  updateIsLoggedIn(context, loggedIn) {
    context.commit("IS_LOGGED_IN_UPDATE", loggedIn);
  },

  updateIsAdmin(context, isAdmin) {
    context.commit("IS_ADMIN_UPDATE", isAdmin);
  },

  setUserDetails({ commit }, payload) {
    commit("setUserDetails", payload);
  },
};

//Data getters
const getters = {
  isAuth(state) {
    return state.isLoggedIn;
  },
  isAdmin(state) {
    return state.isAdmin;
  },
  getUserDetails(state) {
    return state.userDetails;
  },
};
export default {
  mutations,
  actions,
  state: initialState,
  getters,
};
